import { jsx, jsxs } from "react/jsx-runtime";
import { Children, useState } from "react";
import clsx from "clsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../_shadcn-native-components/tabs.js";
import { Button } from "../Button/Button.js";
const ContentTabsRoot = ({ defaultValue, onTabChange, children, ...tabProps })=>{
    const [currentTab, setCurrentTab] = useState(defaultValue);
    const handleTabChange = (value)=>{
        setCurrentTab(value);
        onTabChange(value);
    };
    return /*#__PURE__*/ jsx(Tabs, {
        value: currentTab,
        onValueChange: handleTabChange,
        ...tabProps,
        children: /*#__PURE__*/ jsx("div", {
            className: "tw-flex tw-flex-col tw-w-full",
            children: children
        })
    });
};
const ContentTabsList = ({ children, className })=>{
    const tabCount = Children.count(children);
    return /*#__PURE__*/ jsx(TabsList, {
        className: clsx('tw-w-full tw-bg-neutral-light-100 tw-border-solid tw-border-[1px] tw-border-primary-light-500 tw-rounded-1', className),
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${tabCount}, 1fr)`
        },
        children: children
    });
};
const ContentTabsTrigger = ({ label, value, icon, disabled, className })=>/*#__PURE__*/ jsx(TabsTrigger, {
        asChild: true,
        name: value,
        value: value,
        disabled: disabled,
        className: clsx('tw-flex tw-flex-grow tw-flex-shrink tw-basis-auto tw-justify-center', className),
        children: /*#__PURE__*/ jsx(Button, {
            className: clsx('tw-w-full', !disabled && 'data-[state=inactive]:tw-bg-transparent data-[state=inactive]:tw-text-primary-light-500', !disabled && 'data-[state=active]:tw-bg-primary-light-500 data-[state=active]:tw-text-neutral-light-100', disabled ? 'tw-cursor-default' : 'tw-cursor-pointer'),
            style: {
                borderRadius: 'calc(1rem - 1px)'
            },
            variant: disabled ? 'cancel' : 'primary',
            disabled: disabled,
            type: "button",
            size: "xs",
            children: /*#__PURE__*/ jsxs("span", {
                className: "tw-flex tw-items-center tw-gap-1",
                children: [
                    icon && /*#__PURE__*/ jsx("span", {
                        children: icon({
                            size: 20,
                            className: 'tw-flex tw-text-current tw-self-center'
                        })
                    }),
                    label
                ]
            })
        })
    });
const ContentTabsContent = TabsContent;
const ContentTabsWithComponents = ContentTabsRoot;
ContentTabsWithComponents.List = ContentTabsList;
ContentTabsWithComponents.Trigger = ContentTabsTrigger;
ContentTabsWithComponents.Content = ContentTabsContent;
const ContentTabs = ContentTabsWithComponents;
export { ContentTabs };
